import request from './axios.config'
import axios from 'axios'

const sourceList = [];
/**
 * OneSight获取Token
 * **/
export const getToken = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/onesight/getToken`,
        method: 'get',
        params
    })
}
/**
 * 查询账号列表
 * **/
export const findAccounts = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/findAccounts`,
        method: 'get',
        params
    })
}
/**
 * 查询账号详情
 * **/
export const getAccounts = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getAccounts`,
        method: 'get',
        params
    })
}
/**
 * 授权流程,添加主页
 * **/
export const addOnsightPages = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/addOnsightPages`,
        method: 'post',
        data
    })
}
/**
 * 授权流程,主页列表查询
 * **/
export const getOnsightAuthPages = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getOnsightAuthPages`,
        method: 'post',
        data
    })
}
/**
 * 解绑主页
 * **/
export const removeOnsightPage = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/removeOnsightPage`,
        method: 'get',
        params
    })
}

/**
 * OneSight获取oss临时token
 * **/
export const getOssStsToken = () => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/onesight/getOssStsToken`,
        method: 'get'
    })
}
/**
 * 发帖
 * **/
export const sendPosts = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/sendPosts`,
        method: 'post',
        data
    })
}
/**
 * 
发帖记录分页
 * **/
export const findPage = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/findPage`,
        method: 'post',
        params
    })
}
/**
 * 
发帖记录分页
 * **/
export const findPostDataPage = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/dataStatistic/findPostDataPage`,
        method: 'post',
        data
    })
}
/**
 * 
获取帖子详情
 * **/
export const getDetail = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/getDetail`,
        method: 'get',
        params
    })
}
/**
 * 
更新帖子状态
 * **/
export const updatePost = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/updatePost`,
        method: 'get',
        params
    })
}
/**
 * 
更新帖子链接
 * **/
export const getUrlHtml = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/getUrlHtml`,
        method: 'post',
        data
    })
}
/**
 * 
更新私信用户列表
 * **/
export const findMessageUsers= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/message/findMessageUsers`,
        method: 'post',
        data
    })
}
/**
 * 
私信列表查询
 * **/
export const findMessages= (data) => {
    let source
    if(!data.refresh) {
        const lastSource = sourceList.shift();
        if (lastSource) lastSource.cancel();
        
        const CancelToken = axios.CancelToken;
        source = CancelToken.source();
        sourceList.push(source);
    }
    
    return request({
        url: `/npgw/mwebapi/thirdapp/media/message/findMessages`,
        method: 'post',
        data,
        cancelToken: source ? source.token : ''
    })
}
/**
 * 
回复私信
 * **/
export const replyMessage= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/message/replyMessage`,
        method: 'post',
        data
    })
}
/**
 * 
添加客户
 * **/
export const updateCustInfo= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/user/updateCustInfo`,
        method: 'post',
        data
    })
}
/**
 * 
评论相关
列表
 * **/
export const findComments= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/comment/findComments`,
        method: 'post',
        data
    })
}
/**
 * 
更新状态
 * **/
export const handleStatus= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/comment/handleStatus`,
        method: 'post',
        data
    })
}
/**
 * 
回复
 * **/
export const replyComment= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/comment/replyComment`,
        method: 'post',
        data
    })
}
/**
 * 
设置精选
 * **/
export const setWinnow= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/comment/setWinnow`,
        method: 'post',
        data
    })
}
/**
 * 
设置精选
 * **/
export const handleStatusBatch= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/comment/handleStatusBatch`,
        method: 'post',
        data
    })
}
/**
 * 
平台账户数据明细查询
 * **/
export const getAccountDataDetail= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/dataStatistic/getAccountDataDetail`,
        method: 'get',
        params
    })
}
/**
 * 
平台账户数据列表查询
 * **/
export const getAccountsData= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/dataStatistic/getAccountsData`,
        method: 'get',
        params
    })
}
/**
 * 
首页IM红点数量统计 
 * **/
export const getRedNum= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/dataStatistic/getRedNum`,
        method: 'get',
        params
    })
}
export const getCommentNewsNum= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/dataStatistic/getCommentNewsNum`,
        method: 'get',
        params
    })
}
//微博
/* 
获取授权页接口
 * **/
export const auth2url= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/auth2url`,
        method: 'get',
        params
    })
}
/* 
绑定微博账号
 * **/
export const weiboAccount= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/weiboAccount`,
        method: 'post',
        params
    })
}
/* 
取消授权
 * **/
export const removeWeiboAccount= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/weiboAccount`,
        method: 'put',
        params
    })
}
/* 
分享微博
 * **/
export const weiboSendPosts= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/weibo/sendPosts`,
        method: 'post',
        data
    })
}
/* 
获取抖音授权地址
 * **/
export const getDouyinOauthUrl= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getDouyinOauthUrl`,
        method: 'post',
        data
    })
}
/* 
绑定抖音账号
 * **/
export const bindDouyinAccount= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/bindDouyinAccount`,
        method: 'get',
        params
    })
}
/* 
解绑抖音账号
 * **/
export const unbindDouyinAccount= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/unbindDouyinAccount`,
        method: 'get',
        params
    })
}
/* 
抖音查询留资卡片
 * **/
export const getDouyinRetainConsultCards= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/message/getDouyinRetainConsultCards`,
        method: 'get',
        params
    })
}
/* 
获取快手授权地址
 * **/
export const getKuaishouOauthUrl= (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getKuaishouOauthUrl`,
        method: 'post',
        data
    })
}
/* 
绑定快手账号
 * **/
export const bindKuaishouAccount= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/bindKuaishouAccount`,
        method: 'get',
        params
    })
}
/* 
解绑快手账号
 * **/
export const unbindKuaishouAccount= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/unbindKuaishouAccount`,
        method: 'get',
        params
    })
}
/* 
快手获取upload_token
 * **/
export const getKuaishouUploadToken= (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/getKuaishouUploadToken`,
        method: 'get',
        params
    })
}
/**
 * 快手发帖
 * **/
export const kuaishouSendPosts = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/kuaishou/sendPosts`,
        method: 'post',
        data
    })
}
/**
 * 快手直接上传
 * **/
export const upload = (baseURL, params, data) => {
    return request({
        url: `/api/upload/multipart`,
        method: 'post',
        data,
        params,
        baseURL,
        dataType: 'file',
        timeout: 1000 * 60 * 60,
        delPublicParams: true // 不带公有参数
    })
}
/**
 * 快手上传分片
 * **/
export const fragment = (baseURL, params, data) => {
    return request({
        url: `/api/upload/fragment`,
        method: 'post',
        data,
        params,
        baseURL,
        timeout: 1000 * 60 * 60,
        delPublicParams: true // 不带公有参数
    })
}
/**
 * 快手完成分片上传
 * **/
export const complete = (baseURL, params) => {
    return request({
        url: '/api/upload/complete',
        method: 'post',
        params,
        baseURL,
        delPublicParams: true // 不带公有参数
    })
}
/**
 * 快手断点续传
 * **/
export const resume = (baseURL, params) => {
    return request({
        url: '/api/upload/resume',
        method: 'get',
        params,
        baseURL,
        delPublicParams: true // 不带公有参数
    })
}
/**
 * 判断社媒是否开通了AI客服接口
 * **/
export const openDetail = (data) => {
    return request({
        url: 'npgw/visitormanager/intelligent/manager/social/openDetail',
        method: 'post',
        data,
    })
}
/**
 * 判断社媒是否开通了AI客服接口
 * **/
export const updateMessageAiTag = (data) => {
    return request({
        url: 'npgw//mwebapi/thirdapp/media/message/updateMessageAiTag',
        method: 'post',
        data,
    })
}
//wahtsapp 接口
/**
 * WhatsApp获取授权二维码
 * **/
export const getWhatsAppQrCode = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getWhatsAppQrCode`,
        method: 'get',
        params
    })
}
/**
 * WhatsApp查询授权状态
 * **/
export const getWhatsAppStatus = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getWhatsAppStatus`,
        method: 'get',
        params
    })
}
/**
 * 解绑WhatsApp账号
 * **/
export const unbindWhatsAppAccount = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/unbindWhatsAppAccount`,
        method: 'get',
        params
    })
}
/**
 * 解绑WhatsApp账号
 * **/
export const getWhatsAppOpenAccount = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getWhatsAppOpenAccount`,
        method: 'get',
        params
    })
}
export const getSnsToken = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/sns/getToken`,
        method: 'get',
        params
    })
}
//绑定账号
export const bindAccount = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/sns/bindAccount`,
        method: 'post',
        data
    })
}
export const getSessionStatus = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/sns/getSessionStatus`,
        method: 'get',
        params
    })
}
export const unbindAccount = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/sns/unbindAccount`,
        method: 'get',
        params
    })
}
export const douyinSendPosts = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/sns/sendPosts`,
        method: 'post',
        data
    })
}
//维护平台信息
export const findList = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/platform/findList`,
        method: 'get',
        params
    })
}
//获取whatsapp账号消息状态
export const findAccountsRedNum = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/findAccountsRedNum`,
        method: 'post',
        data
    })
}
export const getBuyNum = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/getBuyNum`,
        method: 'get',
        params
    })
}
//查询客户购买的所有产品
export const getProducts = (params) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/cust/getProducts`,
        method: 'get',
        params
    })
}
//查询账号所属产品
export const findLookProducts = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/findLookProducts`,
        method: 'post',
        data
    })
}
//设置账号所属产品
export const setProductsForAccount = (data) => {
    return request({
        url: `/npgw/mwebapi/thirdapp/media/account/setProductsForAccount`,
        method: 'post',
        data
    })
}